module.exports = __webpack_public_path__ + "static/media/versace-crystal-noir-big.5b202c03.png";